import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserDataServiceInterface } from '@discoverer/attachments/services/user-data-service-interface.service';
import { DynFormComponent } from '@discoverer/dynamic-forms/dyn-forms/dyn-form/dyn-form.component';
import { FormsDataServiceInterface, HttpFormsDataService } from '@discoverer/dynamic-forms/dyn-forms/services';
import { OptionDataServiceInterface, OptionListDataServiceInterface } from '@discoverer/dynamic-forms/option-lists/shared-services/data-service';
import { HasuraOptionListService } from '@discoverer/dynamic-forms/option-lists/shared-services/hasura-option-list-service';
import { HasuraOptionService } from '@discoverer/dynamic-forms/option-lists/shared-services/hasura-option-service';
import { UserDataService } from '@discoverer/app-core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'new-employee-dialog',
    templateUrl: './new-employee-dialog.html',
    styleUrls: ['./new-employee-dialog.scss'],
    providers: [
        { provide: FormsDataServiceInterface, useClass: HttpFormsDataService, deps: [HttpClient] },
        { provide: OptionListDataServiceInterface, useClass: HasuraOptionListService },
        { provide: OptionDataServiceInterface, useClass: HasuraOptionService },
        { provide: UserDataServiceInterface, useExisting: UserDataService }
    ]
})
export class NewEmployeeDialogComponent implements OnInit {
    @ViewChild('dynForm') dynForm: DynFormComponent;

    constructor(
        public dialogRef: MatDialogRef<NewEmployeeDialogComponent>,
        defaultForm: FormsDataServiceInterface,
        @Inject(MAT_DIALOG_DATA) public data) {
        (defaultForm as HttpFormsDataService).formServicePath = `/api/es/form/${this.appId}/${this.tabId}`;
    }


    public appId = 'ats';
    public tabId = 'employees';

    close() {
        this.dialogRef.close();
    }

    onSubmit(event) {
        if (event) {
            this.dialogRef.close(event);
        }
    }

    async ngOnInit() {
        this.data = {
            Type: 'Employee'
        };
    }
}
